export function api(): string {
  return 'Here is a message from the shared api lib';
}
